import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Product} from '../../interface/product';
import {Router} from '@angular/router';
import {BrowserAPIService} from "@bloomscorp/ngbase";
import {Image} from "../../../interface/image";
import {isEmptyString} from "bmx-pastebox";
import {ImageGallerySeo} from "../../interface/image-gallery-seo";

@Component({
	selector: 'fb-product-image',
	templateUrl: './product-image.component.html',
	styleUrls: ['./product-image.component.scss']
})
export class ProductImageComponent implements OnInit, OnChanges  {

	@Input() product: Product = {} as Product;
	@Input() dataProductImageAddOn: string = '';
	@Input() dataVideo: string = '';

	public selectedIndexFromThumb: number = 0;
	public galleryImageList: ImageGallerySeo[] = [];
	public productVideo: Image = {} as Image;
	public isMobileDevice: boolean = false;
	public addOnImage: string = '';
	public inc: number = -1;

	constructor(
		private _router: Router,
		private _browser: BrowserAPIService,
	){
	}

	private _setAltTexts(product: Product): void {

		if (isEmptyString(product.heroImageAlt))
			product.heroImageAlt = product.name;

		if (isEmptyString(product.hoverImageAlt))
			product.heroImageAlt = product.name;
	}

	private _prepareGallery(product: Product): void {

		this._setAltTexts(product);

		this.galleryImageList.push({
			image: product.heroImage,
			altText: product.heroImageAlt,
			deleted: false,
		});

		this.galleryImageList.push({
			image: product.hoverImage,
			altText: product.hoverImageAlt,
			deleted: false,
		});

		this.productVideo = {
			url: this.dataVideo,
			altText: product.name
		};


		if(product.imageGallerySEOList && product.imageGallerySEOList.length > 0) {
			product.imageGallerySEOList.forEach((imageGallerySEO: ImageGallerySeo) => {
				this.galleryImageList.push({
					image: imageGallerySEO.image,
					altText: imageGallerySEO.altText,
					deleted: imageGallerySEO.deleted,
				})
			})
		}
	}

	public ngOnInit(): void {
		if (this._browser.isBrowser())
			this.isMobileDevice = window.screen.width <= 745;
		this._prepareGallery(this.product);
	}


	public ngOnChanges(changes: SimpleChanges): void {
		// TODO: addOnImage needs it's own SEO setup while adding to gallery using Image interface
		this.addOnImage = changes['dataProductImageAddOn'].currentValue;
		if (!this.addOnImage) return;
		this.inc += 1;
	}

	public thumbIndex(index: number): void {
		this.selectedIndexFromThumb = index
	}

	public navigate(
		productTypeLink: string,
		paramKey: string,
		paramValue: string
	): void {
		this._router.navigate([productTypeLink,],
			{queryParams: {[paramKey]: paramValue}}).then((): void => {
				if (this._browser.isBrowser())
					window.location.reload()
		});
	}
}
